<template>
    <div class="avatar-icon">
        <!-- USER ICON -->
        <img v-if="user && icon" class="icon active" :src="icon" referrerpolicy="no-referrer" />

        <!-- GROUP ICON -->
        <contact-group-icon v-else-if="user?.isGroupChat" painted></contact-group-icon>

        <!-- USER LOGGED IN, NO ICON -->
        <svg v-else-if="user" width="120" height="120" class="icon painted" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#p7k6n7hl8a)">
                <circle class="circle" cx="60" cy="60" r="55" fill="#fff" />
                <path
                    d="M101.95 98.7c-.25 0-.5-.05-.75-.2-5.9-3.65-16.25-8.65-26.7-12.85v-8.8c2-1.6 5.1-5.45 5.5-14.4 2.4-1.45 3.8-5 3.8-8.4 0-3.05-1.1-5.45-2.9-6.75 1.7-4.35 2.3-9 1.75-13.7-2.05-8.3-12.2-11.1-20.25-11.1-7.3 0-16.3 2.3-19.4 8.65h-.85c-3.15 0-4.7 1.4-5.45 2.55-2.35 3.65.25 9.55 2.05 13.45-2.25 1.35-3.7 4.1-3.7 7.55 0 3.85 1.8 6.85 4.55 7.95.45 8.9 3.8 12.7 5.95 14.25v8.75c-10.45 4.2-20.8 9.2-26.7 12.85-.25.15-.5.2-.75.2-.2 0-.55 0-.85-.35C7.75 87.8 2.55 74.15 2.55 60 2.5 28.3 28.3 2.5 60 2.5c.95 0 1.9 0 2.8.05 28.75 1.4 52.7 24.95 54.55 53.65 1 15.6-4.15 30.55-14.6 42.15-.25.3-.65.35-.85.35h.05z"
                    fill="#D92121"
                />
                <path
                    class="outline"
                    d="M60 5c.9 0 1.8 0 2.7.05 27.5 1.3 50.4 23.85 52.2 51.3.95 14.55-3.75 28.5-13.2 39.5-5.8-3.5-15.1-7.95-24.65-11.9v-6c2.25-2.2 4.85-6.35 5.4-14.2C85 61.55 86.3 57.7 86.3 54c0-2.4-.55-4.6-1.65-6.3-.25-.4-.55-.75-.85-1.1 1.4-4.25 1.85-8.75 1.35-13.25 0-.2-.05-.45-.1-.65C83.1 25 74.2 20 62.4 20c-9.6 0-17.25 3.3-20.85 8.65-4.1.2-6.1 2.35-6.95 3.7-2.7 4.2-.8 9.8 1.05 14.1-1.95 1.95-3.15 4.9-3.15 8.25 0 4.15 1.8 7.65 4.65 9.5.7 7.6 3.5 11.75 5.85 13.85v5.9c-9.55 3.95-18.85 8.4-24.65 11.9C9.75 85.85 5 73.2 5 60c0-14.65 5.75-28.45 16.15-38.85C31.55 10.75 45.35 5 60 5zm0-5C26.9 0 0 26.9 0 60c0 15.35 5.8 29.4 15.35 40.05.7.8 1.7 1.2 2.7 1.2.7 0 1.4-.2 2.05-.6 6.4-3.95 17.8-9.3 27.9-13.3V75.5s-6-2.1-6-14.85c-6 0-6-11.85 0-11.85 0-1.6-8.55-15.1.1-15.1.7 0 1.5.1 2.45.3 1.5-5.95 9.65-8.9 17.8-8.9s16.3 2.95 17.8 8.9c.6 5.1-.35 10.25-2.7 14.85 5.8 0 4.25 11.85 0 11.85 0 12.75-5.5 14.85-5.5 14.85V87.4c10.1 4 21.5 9.3 27.9 13.3.65.4 1.35.6 2.05.6 1 0 2-.4 2.7-1.2 10.35-11.55 16.3-27.1 15.25-44-1.9-30.15-26.8-54.6-56.9-56.05C61.95 0 61 0 60 0z"
                    fill="#6A1D15"
                />
            </g>
            <defs>
                <clipPath id="p7k6n7hl8a">
                    <path d="M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60z" />
                </clipPath>
            </defs>
        </svg>

        <!-- USER NOT LOGGED IN -->
        <svg v-else width="120" height="120" class="icon default" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Icon 24 • Contact" clip-path="url(#bt2jwzhqja)">
                <path
                    d="M101.95 98.7c-.25 0-.5-.05-.75-.2-5.9-3.65-16.25-8.65-26.7-12.85v-8.8c2-1.6 5.1-5.45 5.5-14.4 2.4-1.45 3.8-5 3.8-8.4 0-3.05-1.1-5.45-2.9-6.75 1.7-4.35 2.3-9 1.75-13.7-2.05-8.3-12.2-11.1-20.25-11.1-7.3 0-16.3 2.3-19.4 8.65h-.85c-3.15 0-4.7 1.4-5.45 2.55-2.35 3.65.25 9.55 2.05 13.45-2.25 1.35-3.7 4.1-3.7 7.55 0 3.85 1.8 6.85 4.55 7.95.45 8.9 3.8 12.7 5.95 14.25v8.75c-10.45 4.2-20.8 9.2-26.7 12.85-.25.15-.5.2-.75.2-.2 0-.55 0-.85-.35C7.75 87.8 2.55 74.15 2.55 60 2.5 28.3 28.3 2.5 60 2.5c.95 0 1.9 0 2.8.05 28.75 1.4 52.7 24.95 54.55 53.65 1 15.6-4.15 30.55-14.6 42.15-.25.3-.65.35-.85.35h.05z"
                />
            </g>
            <defs>
                <clipPath id="bt2jwzhqja">
                    <path d="M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60z" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';

import { usePalette, paletteProps, useProfile, ContactGroupIcon } from 'ihunter-pathfinder-components';

const { getStoragePhotoURLForUser } = useProfile();

const props = defineProps({
    ...paletteProps(),
    user: {
        type: Object,
        default: null,
    },
});

const { colorPalette } = usePalette(props);
const icon = ref(null);

onMounted(async () => {
    if (user.value) {
        icon.value = await getStoragePhotoURLForUser(user.value, true);
    }
});

const user = computed(() => {
    return props.user || null;
});

watch(
    () => user?.value?.localUrl,
    async (localUrl) => {
        icon.value = localUrl;
    },
);

watch(
    () => user?.value?.profilePicDate,
    async (profilePicDate) => {
        if (user.value) {
            console.log(`setStoragePhotoURLForUser AvatarIcon - profilePic updated for ${user.value.uid}: ${profilePicDate}`);
            icon.value = await getStoragePhotoURLForUser(user.value, false);
        } else {
            icon.value = null;
        }
    },
);
</script>

<style scoped lang="scss">
@use 'ihunter-pathfinder/styles' as Pathfinder;

.avatar-icon {
    display: flex;
    position: relative;
    align-items: center;
    max-height: Pathfinder.$icon-macro;
    max-width: Pathfinder.$icon-macro;
    // justify-content: center;

    height: 100%;
    width: 100%;
    :deep(svg) {
        height: 100%;
        width: 100%;
    }

    .icon {
        display: flex;
        border-radius: 50%;
        width: 100%;
        height: auto;
        object-fit: cover;
        aspect-ratio: 1;

        path {
            fill: var(--on-surface);
        }

        // &.active {
        //   // border: 1px solid var(--bg);
        // }

        &.painted {
            path {
                fill: var(--brand-box);
            }

            .circle {
                fill: var(--on-surface-fixed);
            }

            .outline {
                fill: var(--brand-box-border);
            }
        }

        &.default {
            //margin: 0;
            fill: var(--on-surface);

            path {
                fill: var(--on-surface);
            }

            .edit {
                margin: 0;
            }

            .circle {
                fill: var(--on-surface-fixed);
            }
        }
    }
}
</style>
